import { RewardsPlusLogo } from "../../common/Icons";
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "underscore";
import { checkSubscriptionStatus, isRPlusMembershipActive, isRPlusMembershipSkipped } from "../../common/utils"
import { removeRewardsPlusSubscription } from "../../actionCreators/cart"

const RewardsPlusMembershipStatusBanner = () => {
    const { cart, user_profile } = useSelector(state => ({
        cart: state.shopifyReducer.cart,
        user_profile: state.myAccountReducer.user_profile,
    }));
    const dispatch = useDispatch();
    const trade_in_bags = sessionStorage.getItem("trade_in_bags") ? JSON.parse(sessionStorage.getItem("trade_in_bags")) : [];
    const trade_in_bags_count = trade_in_bags.length;
    const cartIsEmpty = _.isEmpty(cart) || (cart.lines.length === 0 && trade_in_bags_count === 0);
    const activeMembership = isRPlusMembershipActive(user_profile);
    const skippedMembership = isRPlusMembershipSkipped(user_profile);
    const {isSubscriptionInCart} = checkSubscriptionStatus(cart);

    useEffect(() => {
        if (activeMembership || skippedMembership) {
            if (isSubscriptionInCart) {
                dispatch(removeRewardsPlusSubscription());
            }
        }
    },[])

    if (!(activeMembership || skippedMembership) || cartIsEmpty) {
        return null;
    }

    return (
        <div className={`cart-popup__membership-status ${skippedMembership ? "cart-popup__membership-status--inactive" : ""}`}>
            <RewardsPlusLogo
                style={{ width: 14 }}
                className="cart-popup__membership-status-icon"
                label="Rebag+ Membership"
                color={skippedMembership ? "#767676" : "#2E2E3A"}
            />
            {skippedMembership ? "Inactive" : "Member"}
        </div>
    )
}

export default RewardsPlusMembershipStatusBanner;